module.exports = {
      id: "myvikatanbadge-usage",
      viewBox: "0 0 531.34 560.469",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#myvikatanbadge",
      toString: function () {
        return this.url;
      }
    }